import type { ComparatorType } from 'advanced-filters/data/comparators';
import { ALL_DATA_TYPES, type DataTypeType } from 'advanced-filters/data/dataTypes';
import { DATA_TYPE_TO_OPTIONS_MAP } from 'advanced-filters/data/dataTypeSpecificComparatorOptions';
import { pendingFilterSelector } from 'advanced-filters/selectors/filter';
import { modifyPendingFilter } from 'advanced-filters/store/filter';
import { Select } from 'antd';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Input for Sub Condition based on Base Condition Options
 */
export default function SubConditionComparatorSelect() {
  const dispatch = useDispatch();

  const {
    subConditionKey,
    subConditionComparator,
  } = useSelector(pendingFilterSelector);

  const handleChange = useCallback((value: ComparatorType) => {
    dispatch(modifyPendingFilter({ subConditionComparator: value, subConditionValue: undefined }));
  }, [dispatch]);

  // Activity Note is a special case, it doesn't have a data type
  const dataType = (subConditionKey?.key === ALL_DATA_TYPES.activity_note
    ? ALL_DATA_TYPES.activity_note : subConditionKey?.dataType) as DataTypeType;

  const options = DATA_TYPE_TO_OPTIONS_MAP[dataType];

  useEffect(() => {
    if (!subConditionComparator && options?.length) {
      dispatch(modifyPendingFilter({ subConditionComparator: options[0]?.value }));
    }
  }, [subConditionComparator, dispatch, options]);

  return (
    <Select
      placeholder="Select a Comparision Condition"
      value={subConditionComparator}
      onChange={handleChange}
      options={options as any}
    />
  );
}
